import { render, staticRenderFns } from "./configuration-local-accounting-billable-clients-modal-rules.vue?vue&type=template&id=1c681e8e&"
import script from "./configuration-local-accounting-billable-clients-modal-rules.ts?vue&type=script&lang=ts&"
export * from "./configuration-local-accounting-billable-clients-modal-rules.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-local-accounting-billable-clients-modal-rules.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports